import { render } from "./RulesDetail.vue?vue&type=template&id=6c0d76d0&scoped=true"
import script from "./RulesDetail.vue?vue&type=script&lang=js"
export * from "./RulesDetail.vue?vue&type=script&lang=js"

import "./RulesDetail.vue?vue&type=style&index=0&id=6c0d76d0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c0d76d0"]])

export default __exports__